import { render, staticRenderFns } from "./App.vue?vue&type=template&id=1f9b106e"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
import style0 from "./App.vue?vue&type=style&index=0&id=1f9b106e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../home/li/daga-project/dagasensor-fronend-website/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports